import { render } from "./AdminComponent.vue?vue&type=template&id=5265b396&scoped=true&lang=pug"
import script from "./AdminComponent.vue?vue&type=script&lang=js"
export * from "./AdminComponent.vue?vue&type=script&lang=js"

import "./AdminComponent.vue?vue&type=style&index=0&id=5265b396&lang=sass&scoped=true"

import exportComponent from "D:\\Front\\project\\valeriya.artist\\valeriya.artist.admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5265b396"]])

export default __exports__